import { Component } from '@angular/core';
import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { CompanyService } from 'src/app/_services/company.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
declare var $;

@Component({
  selector: 'popup-sensitive-infomation-types',
  templateUrl: './popup-sensitive-infomation-types.component.html',
  styles: [],
})
export class PopupSensitiveInformationType {
  sensitiveInformationTypes: any[] = [];
  isInformesIA: boolean = false;
  protected ngbModalRef: NgbModalRef;

  constructor(
    public activeModal: NgbActiveModal,
    public companyService: CompanyService,
    public bsModalRef: BsModalRef,
    public toastrService: ToastrService,
    public translateService: TranslateService
  ) {}

  cancel() {
    this.activeModal.dismiss();
  }
}
